// ANT DESIGN IMPORT
import { Card, Col, Flex, Row, Space, Tag, Typography } from "antd";
// ANT DESIGN IMPORT
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  DislikeOutlined,
  SafetyOutlined,
  SettingOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { BOM } from "../../services/definedMethod";

const { Text, Title } = Typography;

export const CollateralFacility = (props) => {
  const { status, prodDetail, name, id } = props;

  return (
    <>
      <Row
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 20,
          marginTop: 24,
          marginBottom: 24,
        }}
      >
        <Card
          style={{
            flex: 1,
            backgroundColor: "#F9FAFB",
            border: "1px solid #EAECF0",
            borderRadius: "12px",
            gridColumn: "2",
          }}
        >
          <Flex justify="space-between">
            <Space direction="vertical" size="middle">
              <div>
                <Text type="secondary">Collateral Name</Text>
                <Title level={5} style={{ marginTop: 4, marginBottom: 0 }}>
                  {name || "-"}
                </Title>
              </div>
              <div>
                <Text type="secondary">Collateral Code</Text>
                <Title level={5} style={{ marginTop: 4, marginBottom: 0 }}>
                  {id || "-"}
                </Title>
              </div>
            </Space>

            <Flex gap="large" justify="end">
              <Col>
                {status
                  ? handleFlgStatus(
                      status,
                      {
                        padding: "2px 12px",
                        borderRadius: "16px",
                        fontSize: "12px",
                        fontWeight: 500,
                        display: "inline-block",
                        textTransform: "capitalize",
                      },
                      false,
                      prodDetail,
                    )
                  : "-"}
              </Col>
            </Flex>
          </Flex>
        </Card>
      </Row>
    </>
  );
};

const statusStyles = {
  approved: {
    bgColor: "#EEF4FF",
    textColor: "#3538CD",
    border: "1px solid #C7D7FE",
  },
  active: {
    bgColor: "#ECFDF3",
    textColor: "#067647",
    border: "1px solid #ABEFC6",
  },
  success: {
    bgColor: "#f0f9ff",
    textColor: "#16a34a",
    border: "1px solid #87d068",
  },
  "active in bad standing": {
    bgColor: "#FEF3F2",
    textColor: "#FA0008",
    border: "1px solid #fca5a5",
  },
  rejected: {
    bgColor: "#FEF3F2",
    textColor: "#FA0008",
    border: "1px solid #fca5a5",
  },
  "premature closed": {
    bgColor: "#FEF3F2",
    textColor: "#FA0008",
    border: "1px solid #fca5a5",
  },
  closed: {
    bgColor: "#FEF3F2",
    textColor: "#FA0008",
    border: "1px solid #fca5a5",
  },
  default: {
    // bgColor: "#FFEB86",
    textColor: "black",
    border: "1px solid #FFEB86",
  },
};

export const handleFlgStatus = (
  status,
  style = {},
  isListing = false,
  otherParams = {},
) => {
  switch (status.toLowerCase()) {
    case "approved":
      return (
        <Tag
          icon={<SafetyOutlined />}
          color={`${isListing ? "purple" : "#EEF4FF"}`}
          style={{ color: "#3538CD", border: "1px solid #C7D7FE", ...style }}
        >
          {status}
        </Tag>
      );
    case "matured":
      return (
        <Tag
          color={`${isListing ? "purple" : "#F9FAFB"}`}
          style={{ color: "#344054", border: "1px solid #EAECF0", ...style }}
        >
          {status}
        </Tag>
      );
    case "pending":
      return (
        <Tag
          icon={<SyncOutlined spin />}
          color={`${isListing ? "orange" : "#F4F3FF"}`}
          style={{
            color: "#5925DC",
            border: "1px solid #D9D6FE",
            ...style,
          }}
        >
          {status}
        </Tag>
      );
    case "disabled":
      return (
        <Tag
          icon={<DislikeOutlined />}
          color={`${isListing ? "grey" : "#F9FAFB"}`}
          style={{ color: "#344054", border: "1px solid #EAECF0", ...style }}
        >
          {status}
        </Tag>
      );
    case "active" || "success":
      if (otherParams?.inArrears) {
        return (
          <Tag
            icon={<CheckCircleOutlined />}
            color={`${isListing ? "red" : "#FA0008"}`}
            style={style}
          >
            {"Active in Bad Standing"}
          </Tag>
        );
      } else {
        return (
          <Tag
            // icon={<CheckCircleOutlined />}
            color={"#067647"}
            style={{
              border: "1px solid #ABEFC6",
              backgroundColor: "#ECFDF3",
              color: "#067647",
              padding: "2px 12px",
              borderRadius: "16px",
              fontSize: "12px",
              fontWeight: 500,
              display: "inline-block",
              textTransform: "capitalize",
            }}
          >
            {status}
          </Tag>
        );
      }
    case "rejected":
    case "premature closed":
    case "closed":
    case "closed early":
      return (
        <Tag
          icon={<CloseCircleOutlined />}
          color={`${isListing ? "red" : "#FEF3F2"}`}
          style={{
            color: "#B42318",
            border: "1px solid #FECDCA",
            ...style,
          }}
        >
          {status}
        </Tag>
      );
    default:
      return (
        <Tag
          icon={<ClockCircleOutlined />}
          color={`${isListing ? "warning" : "#FFEB86"}`}
          style={{ color: "black", ...style }}
        >
          {BOM.SubstringFormat(status, 21)}
        </Tag>
      );
  }
};

export const handleCollateralActionButtons = (collateralDetail) => {
  const status = collateralDetail?.status?.value;

  switch (status?.toLowerCase()) {
    case "submitted and pending approval":
      return [
        {
          label: "Approve",
          key: "1",
          route: "/collateral-action",
          disabled: !BOM.HasPermission("APPROVE_COLLATERAL"),
          icon: <SafetyOutlined />,
        },
      ];
    case "approved":
      return [
        {
          label: "Pledge",
          key: "2",
          route: "/collateral-action",
          // disabled: !BOM.HasPermission("PLEDGE_COLLATERAL"),
          disabled: true,
          icon: <CheckCircleOutlined />,
        },
        {
          label: "Release",
          key: "3",
          route: "/collateral-action",
          // disabled: !BOM.HasPermission("RELEASE_COLLATERAL"),
          disabled: true,
          icon: <SettingOutlined />,
        },
        {
          label: "Liquidate",
          key: "4",
          route: "/collateral-action",
          // disabled: !BOM.HasPermission("LIQUIDATE_COLLATERAL"),
          disabled: true,
          icon: <CloseCircleOutlined />,
        },
      ];
    case "rejected":
      return [
        {
          label: "Apply Haircut",
          key: "5",
          route: "/collateral-action",
          disabled: !BOM.HasPermission("APPLY_HAIRCUT_COLLATERAL"),
          icon: <DislikeOutlined />,
        },
      ];
    default:
      return [];
  }
};
